import { createStudentIdentityResolver } from "./studentIdentityStore";

function collectTargetElements(root = document) {
  const elements = [];
  const scope = root && typeof root.querySelectorAll === "function" ? root : document;

  if (root instanceof Element && root.matches("[data-name-mask]")) {
    elements.push(root);
  }

  scope.querySelectorAll("[data-name-mask]").forEach((element) => {
    if (element instanceof HTMLElement) {
      elements.push(element);
    }
  });

  return elements;
}

function parseNameMaskReference(value) {
  const rawValue = String(value ?? "").trim();
  const separatorIndex = rawValue.indexOf("_");

  if (separatorIndex <= 0 || separatorIndex === rawValue.length - 1) {
    return null;
  }

  const schoolId = rawValue.slice(0, separatorIndex).trim();
  const identifier = rawValue.slice(separatorIndex + 1).trim();

  if (!schoolId || !identifier) {
    return null;
  }

  return { schoolId, identifier };
}

export function redactStudentNameMasks(root) {
  root.querySelectorAll("[data-name-mask], [data-screenshot-text]").forEach((element) => {
    const replacement = element.dataset.screenshotText
      ?? element.dataset.nameMaskOriginal
      ?? parseNameMaskReference(element.dataset.nameMask)?.identifier
      ?? "";

    // The capture document belongs to an iframe, so avoid cross-window instanceof checks.
    if (element.tagName === "INPUT" || element.tagName === "TEXTAREA") {
      element.value = replacement;
      element.setAttribute("value", replacement);
      if (element.tagName === "TEXTAREA") element.textContent = replacement;
    } else {
      element.textContent = replacement;
    }
  });

  root.querySelectorAll('form[data-mask-search] input[name="q"], [data-group-search]').forEach((input) => {
    input.value = "";
    input.setAttribute("value", "");
  });
}

export function applyStudentNameMasks(root = document) {
  const elements = collectTargetElements(root);
  if (elements.length === 0) {
    return;
  }

  const resolver = createStudentIdentityResolver();
  const elementsBySchool = new Map();

  elements.forEach((element) => {
    const reference = parseNameMaskReference(element.dataset.nameMask);
    if (!reference) {
      return;
    }

    if (typeof element.dataset.nameMaskOriginal === "undefined") {
      element.dataset.nameMaskOriginal = String(element.textContent).trim() ?? "";
    }

    const schoolElements = elementsBySchool.get(reference.schoolId) ?? [];
    schoolElements.push({
      element,
      identifier: reference.identifier,
    });
    elementsBySchool.set(reference.schoolId, schoolElements);
  });

  elementsBySchool.forEach((schoolElements, schoolId) => {
    const schoolEntries = resolver.getEntriesForSchool(schoolId);

    schoolElements.forEach(({ element, identifier }) => {
      let originalText = element.dataset.nameMaskOriginal ?? "";
      let maskedName = String(schoolEntries[identifier] ?? "").trim();

      if (maskedName) {
        maskedName = (originalText ? `<small>#${originalText}</small> ` : "") + maskedName;
      }
      element.innerHTML = maskedName || originalText;
    });
  });
}
